import { jsx as _jsx } from "react/jsx-runtime";
import { vui } from '../core';
import Heading from './heading';
export const H1 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h1", ...props }));
export const H2 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h2", ...props }));
export const H3 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h3", ...props }));
export const H4 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h4", ...props }));
export const H5 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h5", ...props }));
export const H6 = vui((props, ref) => _jsx(Heading, { ref: ref, size: "h6", ...props }));
